import moment from 'moment';
import { MilestoneHistoryType, StoryHistoryType, CommonHistoryType } from '@/api/history';
import { subscribe } from 'diagnostics_channel';
export const KR = {
  metadata: {
    title: 'EPOSO: IT 프로젝트 관리의 새로운 표준',
    description:
      'EPOSO로 IT 프로젝트의 투명성을 높이고, 일정 준수율을 개선하며, 이슈를 효과적으로 관리하세요. 실시간 모니터링, 직관적인 일정 관리, 체계적인 이슈 트래킹으로 프로젝트 성공률을 높입니다. EPOSO와 함께 더욱 쉽고 빠르게 IT 프로젝트를 운영하세요.',
    keywords:
      'IT 프로젝트 관리, 프로젝트 모니터링, 일정 관리, 이슈 트래킹, 팀 협업, 프로젝트 대시보드, 소프트웨어 개발 관리, 프로젝트 가시성, 프로젝트 지연 방지, 개발자 리소스 관리, IT 아웃소싱',
  },
  messages: {
    copySuccess: '클립보드에 복사되었습니다.',
    copyFailed: '클립보드 복사에 실패했습니다.',
  },
  common: {
    confirm: '확인',
    client: '고객',
    professional: '전문가',
    delete: '삭제',
    link: '링크',
    edit: '수정',
    request: '요청',
    month: '월', // when english, no text
    save: '저장',
    cancel: '취소',
    next: '다음',
    prev: '이전',
    add: '추가',
    threadAdd: '스레드 추가',
    textLengthLimit: (length: number) => `${length}자 이내 텍스트`,
    role: {
      manager: '관리자',
      professional: '전문가',
      client: '고객',
    },
    webhook: {
      slack: 'Slack',
      teams: 'Teams',
      dooray: 'Dooray',
      discord: 'Discord',
    },
    project: '프로젝트',
    epic: '에픽',
    justAfter: '방금',
    minLater: (n: number) => `${n}분 전`,
    hourLater: (n: number) => `${n}시간 전`,
    today: '오늘',
    history: '기록',
    none: '없음',
    unAssigned: '할당되지 않음',
    showMore: '더보기',
    showLess: '접기',
    startDate: '시작일',
    endDate: '마감일',
    formatDt: (date: any, initFormat: string, customFormat: string) =>
      initFormat
        ? moment
            .utc(date, initFormat)
            .local()
            .format(customFormat ? customFormat : 'YYYY.MM.DD')
        : moment(date).format(customFormat ? customFormat : 'YYYY.MM.DD'),
    deleteNoti: '모든 내용이 삭제되고 복구할 수 없습니다.정말 삭제하시겠습니까?',
    home: '홈',
    story: '스토리',
    milestone: '마일스톤',
    title: '제목',
    noData: '데이터가 없습니다.',
    setting: '환경',
    status: '상태',
    manager: '담당자',
    reporter: '보고자',
    detail: '내용',
    send: '발신',
    reject: '거부',
    sign: '서명',
    keyword: '키워드',
    doclist: '문서',
    create: '생성',
  },
  error: {
    apiErrorGeneral: 'API 요청에 실패했습니다.',
  },
  modal: {
    docType: {
      title: 'AI 문서 생성',
      docTypeLabel: '문서 유형',
      report: '보고서',
      plan: '계획서',
      dateLabel: '기준일자',
      placeholder: '날짜 선택',
      createBtn: '생성',
      cancelBtn: '취소',
      alertSelectDate: '기준일자를 선택해주세요.',
      alertSelectDocType: '문서 유형을 선택해주세요.',
      errorPrefix: '오류: ',
      creatingReport: '문서 생성 중...',
      reportIconAlt: '보고서 아이콘',
      planIconAlt: '계획서 아이콘',
    },
  },

  component: {
    join: {
      emailAuth: '이메일 인증',
      emailAuthMsg: `"인증하기" 클릭 시 이메일이 인증됩니다.`,
      auth: '인증하기',
      authComment: [
        '인증이 정상적으로 진행되지 않을 경우,',
        '아래 링크를 복사하여,인터넷창에 붙여넣어주세요.',
      ],
    },
    starPost: {
      placeholder: '내용을 입력하세요.',
    },
    stateButton: {
      completed: '완료',
      inProgress: '진행',
      pending: '대기',
    },
    githubSyncModal: {
      sync: 'GitHub 동기화',
      runSync: '동기화 실행',
      syncRequested: '동기화가 요청되었습니다. 완료되면 알려드립니다.',
      syncStarted: '동기화 진행이 시작되었습니다.',
      loadingInitial: '연결 정보를 불러오는 중입니다...',
      noConnection: '연결된 GitHub 계정이 없습니다.',
      connectFirst: '먼저 GitHub 계정을 연결해주세요.',
      connectGithub: 'GitHub 계정 연동하기',
      selectAccount: '계정을 선택하세요',
      selectRepository: '저장소를 선택하세요',
      selectBranch: '브랜치를 선택하세요',
      githubAccount: 'Github 계정',
      repositorySelect: '저장소 선택',
      branchSelect: '브랜치 선택',
      fetchInstallationsFailed: 'GitHub 연동 정보를 가져오는 데 실패했습니다.',
      noAccessibleRepos: '접근 가능한 저장소가 없습니다.',
      connectionRemoved: 'GitHub 연결이 제거된 것 같습니다. 목록을 새로고침합니다.',
      fetchReposFailed: '저장소 목록을 불러오는 데 실패했습니다.',
      noBranches: '저장소에 브랜치가 없습니다.',
      fetchBranchesFailed: '브랜치 목록을 불러오는 데 실패했습니다.',
      syncFailed: '동기화에 실패했습니다.',
      connectionSuccess: 'GitHub 계정이 성공적으로 연동되었습니다.',
      connectionCanceled: '사용자가 GitHub 연동을 취소했습니다.',
      connectionError: 'GitHub 연동 중 오류가 발생했습니다.',
      getInstallUrlFailed: 'GitHub 앱 설치 URL을 가져오는 데 실패했습니다.',
      installPageError: 'GitHub 앱 설치 페이지로 이동하는 중 오류가 발생했습니다.',
    },
    githubLinkModal: {
      linkRepository: '저장소 연결',
      editRepository: '저장소 정보 수정',
      linkAction: '연결',
      editAction: '수정',
      linkFailed: '저장소 연결에 실패했습니다.',
      linkSuccess: '저장소를 성공적으로 연결했습니다.',
      editFailed: '저장소 정보 수정에 실패했습니다.',
      editSuccess: '저장소 정보를 성공적으로 수정했습니다.',
      label: '라벨',
      description: '설명',
      initRepo: '저장소 초기화',
      initRepoDesc: '브랜치를 찾을 수 없습니다. 저장소를 초기화하여 `main` 브랜치를 생성하세요.',
      initRepoButton: '`main` 브랜치 생성',
      initSuccess: '저장소를 성공적으로 초기화했습니다.',
      initFailed: '저장소 초기화에 실패했습니다.',
    },
    baseInput: {
      errorOccurred: '오류 발생:',
    },
    alert: {
      confirm: '확인',
      cancel: '취소',
    },

    recruitment: {
      applyTitle: '프로젝트 지원',
      applyButton: '프로젝트 지원',
      applySuccess: '담당자 메일로 지원 메시지가 발송되었습니다.',
      editTitle: '공고 작성',
      editDelete: '삭제',
      editConfirm: '작성',
    },
    project: {
      inviteTitle: '프로젝트 초대',
    },
    gannt: {
      aiScheduleGenerate: '파일 업로드로 AI 일정 생성하기',
      githubSyncTitle: 'GitHub 연동 및 동기화',
    },
    doclist: {
      clipboardFailed: '클립보드 복사에 실패했습니다.',
    },
    header: {
      convertClient: '고객으로 전환하였습니다.',
      convertProfessional: '전문가로 전환하였습니다.',
      noLoggedIn: '가입하고 서비스를 이용해보세요',
      loginJoin: '로그인/회원가입',
      dashboard: '대시보드',
      timeline: '일정',
      settlement: '정산',
      settings: '프로젝트 설정',
      profile: '프로필',
      logout: '로그아웃',
      addLink: '링크 추가',
      pilot: '파일럿',
    },
    noProject: {
      title: '프로젝트가 없습니다',
      text: '프로젝트에 참여하거나 새로 만들어보세요.',
      button: '홈으로 이동',
    },
    taskEditor: {
      thread: '스레드',
      comment: '댓글',
      commentPlaceholder: '댓글 내용을 입력합니다.',
      enterComment: '댓글을 입력하세요.',
      record: '기록',
      enterYourStory: 'Enter your story.',
      period: '진행 기간',
      progressStatus: '진행 상태',
      manager: '담당자',
      reporter: '보고자',
      approvalRequest: '승인 요청',
      approve: '승인',
      reject: '반려',
      storyComplete: '완료',
      storyReject: '거부',
      aiTooltip: '제목을 입력하고 Generate AI 클릭시 제목에 맞는 스토리를 자동 작성합니다.',
      createSentence: '문장을 만들고 있습니다. 잠시만 기다려주세요.',
      storyPoint: '스토리 포인트',
      searchAssignee: '담당자 검색',
      searchReporter: '보고자 검색',
      aiGenerating: 'AI가 작성합니다.',
      defaultTitle: '작성',
    },
    noComment: {
      text: '스레드를 작성해 보세요.',
      title: '작성된 스레드가 없습니다.',
    },
    taskComment: {
      confirmDelete: '삭제하시겠습니까?',
      confirmCloseComment: '수정 중인 내용이 있습니다. 정말 나가시겠습니까?',
    },
    historyList: {
      getTitleChange: (
        type: MilestoneHistoryType | StoryHistoryType | CommonHistoryType,
        typeTask: 'milestone' | 'story',
      ): string => {
        const storyText = {
          [CommonHistoryType.CREATE]: '스토리를 추가했습니다.',
          [CommonHistoryType.CHANGE_TITLE]: '제목을 변경했습니다.',
          [CommonHistoryType.CHANGE_DESCRIPTION]: '설명을 변경했습니다.',
          [CommonHistoryType.CHANGE_APPROVER_ASSIGNEE]: '담당자를 변경했습니다.',
          [CommonHistoryType.CHANGE_REPORTER]: '보고자를 변경했습니다.',
          [CommonHistoryType.CHANGE_LINK]: '링크를 수정했습니다.',
          [CommonHistoryType.CHANGE_SCHEDULE]: '진행기간을 변경했습니다.',
          [CommonHistoryType.CHANGE_STATUS]: '상태를 변경했습니다.',
          [CommonHistoryType.AUTO_CHANGE_STATUS]: '상태가 변경되었습니다.',
          [StoryHistoryType.CHANGE_EPIC]: '에픽을 변경했습니다.',
          [CommonHistoryType.CREATE_COMMENT]: '댓글을 입력했습니다.',
        };
        const milestoneText = {
          [CommonHistoryType.CREATE]: '마일스톤을 추가했습니다.',
          [CommonHistoryType.CHANGE_TITLE]: '제목을 변경했습니다.',
          [CommonHistoryType.CHANGE_DESCRIPTION]: '설명을 변경했습니다.',
          [CommonHistoryType.CHANGE_APPROVER_ASSIGNEE]: '담당자를 변경했습니다.',
          [CommonHistoryType.CHANGE_REPORTER]: '보고자를 변경했습니다.',
          [CommonHistoryType.CHANGE_LINK]: '링크를 수정했습니다.',
          [CommonHistoryType.CHANGE_SCHEDULE]: '진행기간을 변경했습니다. ',
          [CommonHistoryType.CHANGE_STATUS]: '상태를 변경했습니다.',
          [CommonHistoryType.AUTO_CHANGE_STATUS]: '상태가 변경되었습니다.',
          [MilestoneHistoryType.REQUEST_APPROVED]: '승인요청하였습니다.',
          [MilestoneHistoryType.APPROVED]: '승인하였습니다.',
          [MilestoneHistoryType.REJECT]: '반려하였습니다.',
          [CommonHistoryType.CREATE_COMMENT]: '댓글을 입력했습니다.',
        };
        return typeTask === 'milestone'
          ? milestoneText[type as MilestoneHistoryType | StoryHistoryType]
          : storyText[type as CommonHistoryType | StoryHistoryType];
      },
    },
    addRequest: {
      makeRequest: '요청하기',
      requestPlaceholder: '업무 요청 드립니다.',
    },
    addContract: {
      makeContract: '계약하기',
      recipient: '수신자',
      sender: '발신자',
    },
    timelineFilter: {
      milestoneStatus: '마일스톤 상태',
      storyStatus: '스토리 상태',
      resetFilter: '필터 초기화',
      keywordPlaceholder: '스토리 검색',
    },
    workingHour: {
      setWorkingHour: '근무 시간 설정',
      workingHour: '근무 시간',
      commuteTime: '출퇴근 시각',
      applyPeriod: '기간 일괄 적용',
    },
    warningSubscription: {
      warning:
        '프로젝트 시트가 부족합니다. 3일내로 구독 시트를 늘리거나, 담당자를 삭제해 주세요. 이후 프로젝트를 이용할 수 없습니다.',
    },
    githubSync: {
      githubSync: 'Github 동기화',
      runSync: '동기화 실행',
    },
  },
  views: {
    home: {
      slideItem: [
        {
          title: `자유롭게 <span>시간을 선택</span>하여 일해 보세요.`,
          subtext: `프리랜서분들의 작업시간을 스토리에 설정할 수 있습니다.<br>일한 시간만큼 정산받아보세요.`,
        },
        {
          title: `프로젝트를 <span>어디에 맡길지</span> 막막한가요?`,
          subtext: `Eposo에 개발 공고를 올려보세요.<br>지원자 프로필을 확인하고 계약해 보세요.`,
        },
        {
          title: `<span>개발한 내용</span>이 생각한 것과 다른가요?`,
          subtext: `고객과 전문가간의 소통으로 개발 Risk를 줄여보세요.<br>Eposo에서는 단계별로 고객과 전문가가 협의하고 개발을 진행합니다.`,
        },
      ],
      slogan: 'IT 프로젝트 관리의 혁신',
      landingWrap: [
        'IT 프로젝트 관리의 불투명성, 일정 지연, 이슈 관리의 어려움을 EPOSO가 해결합니다.',
        'EPOSO는 실시간으로 변경되는 IT 프로젝트 관리의 표준을 제시합니다.',
      ],
      go: '무료로 프로젝트 만들러 가기',
      point: '포인트',
      onPrepared: '출시를 준비하고 있어요',
      onPreparedShort: '준비 중',
      pointText: [
        {
          title: '체계적인 이슈 트래킹',
          text: [
            '프로젝트 진행 시 발생한 문제를 즉시 등록하고 추적합니다.',
            '이슈 해결 과정을 투명하게 관리하여 프로젝트 리스크를 줄입니다.',
          ],
          comment: '지연된 이슈를 손쉽게 확인할 수 있어요.',
        },
        {
          title: '효율적인 일정 관리',
          text: [
            '직관적인 인터페이스로 복잡한 일정을 체계적으로 관리합니다.',
            '타임라인 시각화로 일정 관리가 더욱 쉬워집니다.',
          ],
          comment: '타임라인 시각화로 일정 관리가 더욱 쉬워집니다.',
        },
        {
          title: '투명한 프로젝트 관리',
          text: [
            '실시간 대시보드로 프로젝트 전체를 한눈에 파악합니다.',
            '진행 상황을 명확히 보고 신속한 의사결정이 가능해집니다.',
          ],
          comment: '고객의 승인을 받고, 작업을 시작해 서로의 고민을 줄일 수 있어요.',
        },
        {
          title: '정확한 인력 관리',
          text: [
            '인력 투입 현황과 참여율을 효과적으로 관리합니다.',
            '프로젝트 정산의 정확성과 효율성이 높아집니다.',
          ],
          comment: '프로젝트에서 일한 시간 만큼 간편하게 정산해 보세요.',
        },
        {
          title: '글로벌 인재 연결',
          text: [
            '다양한 지역의 우수한 인재들과 프로젝트를 연결합니다.',
            '프로젝트에 가장 적합한 인재를 쉽게 찾을 수 있습니다.',
          ],
          comment: '개발이 필요한 프로젝트를 올려 지원자를 모집해 보세요.',
        },
        {
          title: 'AI 프로젝트 자동 생성',
          text: [
            '몇가지 질문만으로 프로젝트를 자동으로 생성합니다.',
            'AI가 제안하는 개발 기능리스트를 받아 바로 개발을 시작해보세요.',
          ],
          comment: 'AI가 프로젝트를 손쉽게 생성해 드립니다.',
        },
      ],
      pointImg: [
        require('@/assets/images/main/randing1.png'),
        require('@/assets/images/main/randing2.png'),
        require('@/assets/images/main/randing3.png'),
        require('@/assets/images/main/randing4.png'),
        require('@/assets/images/main/randing5.png'),
        require('@/assets/images/main/randing6.png'),
        require('@/assets/images/main/randing7.png'),
      ],
      tail: [
        'EPOSO로 프로젝트 가시성을 높이고, 관리 효율성을 극대화하세요.',
        '더 체계적인 프로젝트 관리의 시작, EPOSO와 함께하세요.',
      ],
    },
    login: {
      title: ['SNS로 간편하게 가입하고', '서비스를 이용하세요'],
      googleLogin: '구글 로그인 / 간편 회원 가입',
      emailLogin: '이메일 로그인',
      emailId: '이메일 ID',
      password: '비밀번호',
      join: '회원 가입',
      find: '계정 찾기',
      error: [
        '비밀번호가 올바르지 않습니다.',
        '일치하는 계정 정보가 없습니다.',
        '5회 이상 입력하여 잠금 처리 되었습니다. 비밀번호를 재설정해 주세요.',
        '로그인에 실패했습니다. 다시 시도해주세요.',
      ],
      toast: [
        '',
        '이메일이 발송되었습니다.',
        '잘못된 접근입니다.',
        '패스워드가 변경되었습니다.',
        '',
        '이메일 인증되었습니다.',
        '이메일 인증에 실패했습니다.',
        '탈퇴처리 되었습니다.',
        '이메일 로그인으로 해보세요.',
      ],
    },
    dashboard: {
      process: '진행 / 계획',
      milestone: '마일스톤',
      timeCost: '소모 시간',
      request: '요청사항',
      procRate: '공정률',
      approvalRequest: '승인요청',
      status: '상태',
      approvalDate: '승인일',
      approval: '승인',
      withdrawal: '반려',
      approved: '승인됨',
      processStart: '시작일',
      processEnd: '완료일',
      noApprovalRequest: {
        title: '승인요청한 내용이 없습니다.',
        text: '마일스톤을 작성하고 고객에게 승인을 받을 수 있습니다.',
      },
      milestoneProc: '마일스톤 진행현황',
      noMilestones: {
        title: '마일스톤이 없습니다.',
        text: '마일스톤의 진행 기간이 표시됩니다.',
      },
      myRequests: '내 요청 서비스',
      assignee: '담당자',
      requestDate: '요청일',
      completeDate: '완료일',
      noRequests: {
        title: '요청한 서비스가 없습니다.',
        text: '프로젝트 관련자에게 업무를 요청해 보세요.',
      },
      myContract: '내 계약 현황',
      contract: '계약',
      index: '구분',
      target: '대상',
      sendDate: '발신일',
      contractDate: '계약일',
      send: '발신',
      receive: '수신',
      noContract: {
        title: '진행한 계약이 없습니다.',
        text: '프로젝트 관련자간 계약을 진행해 보세요.',
      },
      progressStory: '진행 중인 스토리',
      noProgressStory: {
        title: '진행 중인 스토리가 없습니다.',
        text: '일정 페이지에서 스토리 일정을 설정해 주세요.',
      },
      holdStory: '지연 중인 스토리',
      noHoldStory: {
        title: '지연 중인 스토리가 없습니다.',
        text: '완료일 이전에 스토리를 완료해 주세요.',
      },
    },
    timeline: {
      status: '상태',
      startDate: '시작일',
      endDate: '마감일',
      addMilestone: '마일스톤 추가',
      waitingStories: '대기 중인 스토리',
      addStory: '스토리 추가',
      creatingTimelineAI: 'AI로 타임라인 생성 중...',
    },
    setting: {
      addProject: '프로젝트 추가',
      projectPeriod: '프로젝트 기간',
      startDate: '시작일',
      endDate: '마감일',
      startDateShorter: '시작일',
      endDateShorter: '마감일',
      dateError: '뒤에 있는 날짜가 앞의 날짜 보다 빠를 수 없습니다.',
      addAsMember: '담당자 이메일로 추가',
      member: '담당자',
      email: '이메일',
      company: '회사',
      role: '역할',
      assign: '담당',
      auth: '권한',
      unfold: '펼치기',
      epic: '에픽',
      weight: '가중치',
      addEpic: '에픽 추가',
      deleteProject: '프로젝트 삭제',
      askDelete: ['정말 삭제하시겠어요?', '프로젝트의 모든 내용이 삭제되고 복구할 수 없어요!'],
      notValidEmail: '올바른 이메일 형식이 아닙니다.',
      successAddMember: '멤버 추가에 성공했습니다.',
      epicLimit: '에픽 개수는 30개 이하로 설정됩니다.',
      deleteAsk: '정말 삭제하시겠습니까?',
      cardRegist: '카드 등록에 성공했습니다.',

      addWebhook: '웹훅 추가',
      webhookLink: '웹훅 링크 URL',
      successAddWebhook: '웹훅 추가에 성공했습니다.',
      notValidUrl: '올바른 URL 형식이 아닙니다.',
      webhookLabel: {
        type: '분류',
        url: 'URL',
        milestone: '마일스톤',
        story: '스토리',
        request: '요청',
        write: '신규',
        update: '수정',
        delete: '삭제',
      },

      // Project Token
      projectTokenTitle: '프로젝트 토큰',
      tokenInputPlaceholder: '외부 서비스 토큰을 입력하세요',
      tokenProvider: '제공자',
      lastUpdated: '수정일',
      noTokenProviders: '등록된 토큰이 없습니다.',
      successSaveToken: '토큰이 저장되었습니다.',
      successDeleteToken: '토큰이 삭제되었습니다.',
      figmaTokenScopeNote: 'Figma 토큰 발급 시 scope에 file_content:read 권한을 꼭 추가하세요.',

      couponRegist: '쿠폰이 정상적으로 등록되었습니다.',
      couponRegistFail: '쿠폰 등록에 실패했습니다.',
      couponExpiredOrNone: '기간이 만료 되었거나 없는 쿠폰입니다.',
      couponIsMontly: '월 결제용 쿠폰입니다.',
      couponIsYearly: '연 결제용 쿠폰입니다.',
      couponAlreadyRegisterd: '이미 등록된 쿠폰입니다.',
      cardRegistFail: '카드 등록에 실패했습니다.',
      subscribe: '구독에 성공했습니다.',
      subscribeFail: '구독에 실패했습니다.',
      refund: '환불에 성공했습니다.',
      enterCoupon: '쿠폰번호를 입력해주세요.',
      refundFail: '환불에 실패했습니다.',
      subscribeAdd: '구독 수 추가에 성공했습니다.',
      subscribeAddFail: '구독 수 추가에 실패했습니다.',
      usedSheets: '사용 시트', // Used Sheets
      sheets: '시트', // Sheets
      sheet: '시트', // Sheet
      free: '무료', // Free
      paid: '유료', // Paid
      subscription: '구독', // Subscription
      subscriptionChange: '구독 변경',
      paymentManagement: '결제 관리', // Payment Management
      registerSubscription: '구독 등록', // Register Subscription
      paymentInfo: '결제 정보', // Payment Information
      usingForFree: '무료 이용 중', // 현재 무료로 사용 중
      usingMonthly: '월 구독 중', // 현재 월 구독 중
      usingYearly: '연 구독 중', // 현재 연 구독 중
      subscriptionInfo: '구독정보', // Subscription Info
      paymentCard: '결제 카드', // Payment Card
      paymentCurrency: '결제 통화', // Payment Currency
      coupon: '사용 쿠폰', // Coupon
      useCoupon: '사용하기', // Use Coupon
      couponInUse: '사용중', // Coupon in Use
      selectCoupon: '쿠폰 선택', // Select Coupon
      registerCoupon: '쿠폰 등록', // Register Coupon
      couponNumber: '쿠폰번호', // Coupon Number
      registerWord: '등록', // Register
      availableCoupon: '보유 쿠폰', // Available Coupon
      choose: '선택', // Select Coupon
      nextPaymentDate: '다음 결제일', // Next Payment Date
      paymentHistory: '결제 내역', // Payment History
      registerCard: '카드 등록', // Register Card
      notRegistered: '미등록', // No registered card

      agreeToTerms: '약관에 동의합니다', // I agree to the terms and conditions
      agreeToPayment: '결제에 동의합니다', // I agree to the payment
      noRecordForPayment: '결제한 내역이 없습니다.', // No record for payment
      cardNumber: '카드번호', // Card Number
      expirationDate: '유효기간', // Expiration Date
      birthDate: '생년월일', // Date of Birth
      businessRegNum: '사업자등록번호', // Business registration number
      businessRegNumPh: "사업자등록번호 ('-' 빼고 입력)", // Business registration number
      corporateCard: '법인카드', // Corporate Card
      ownerName: '소유주명', // Owner Name
      password: '비밀번호', // Password

      partial: '부분', // Partial
      full: '전체', // Full
      cancel: '취소', // Cancel
      save: '저장', // Save
      close: '닫기', // Close
      monthWord: '월', // Month
      yearWord: '년', // Year
      subscribeWord: '구독', // Subscribe

      subscriptionSheets: '구독 시트', // Subscription Sheets
      paymentMethod: '결제 방법', // Payment Method
      monthlyPlanPrice: '월 구독료', // Monthly Plan
      yearlyPlanPrice: '연 구독료', // Yearly Plan
      monthlySubscription: '월 결제', // Monthly Subscription
      yearlySubscription: '연 선 결제', // Yearly Subscription
      subscriptionPeriod: '구독 기간', // Subscription Period
      paymentAmount: '결제 금액', // Payment Amount
      addtionalWord: '추가', // Addtional
      addedCost: '추가 결제 금액', // Added cost
      basicDiscountWord: '기본 할인', // Discount
      couponDiscountWord: '할인',
      refundHistory: '환불 내역', // Refund History
      refundWord: '환불', // Refund
      amountWord: '금액', // Amount
      payWord: '결제', // Pay
      priceWord: '금액', // Price
      totalRefundAmount: '총 환불 금액', // Total Refund Amount
      termLanguage: 'KR', // Term Language
      currency: '원', // Currency
      sheetsAvailable: '시트 사용 가능', // Sheets Available
      total: '총',
      day: '일',
      days: '일',
      use: '사용',
      used: '사용',
      times: '회',

      currencyType: '결제방식',
      currencyKrw: '원화 결제(KRW)',
      currencyUsd: '해외 결제(USD)',
      currencyKrw2: '결제방식 KRW',
      currencyUsd2: '결제방식 USD',
      currencyKrw2Desc: '한국 내에서 결제 가능한 카드만 사용 가능합니다.',
      currencyUsd2Desc: '해외 결제 가능한 카드만 사용 가능합니다.',
      cvv: 'cvv',
      firstName: '이름',
      lastName: '성',
      phoneNumber: '전화번호',
      address: '주소',
      city: '도시',
      state: '주',
      zipcode: '우편번호',
      country: '국가',
      placeholder: {
        address: '주소를 입력해주세요',
        city: '도시를 입력해주세요',
        state: '주/도를 입력해주세요',
        zipCode: '우편번호를 입력해주세요',
      },
      aiProjectCreate: 'AI로 프로젝트 생성하기',
      aiProjectCreateDesc:
        'AI가 프로젝트 시작을 도와드립니다. 프로젝트를 설명하고 기능 리스트부터 개발 일정까지 자동으로 생성해 보세요.',
      generateAI: 'AI 생성',
      inviting: '초대중',
      expert: '전문가',
      adminRequired: '프로젝트에 한 명 이상의 관리자가 필요합니다.',
      select: '선택',

      // AI Tokens
      aiTokensTitle: 'AI 토큰',
      aiTokensPolicy: 'AI 토큰 정책',
      aiTokensLedger: 'AI 토큰 원장',
      aiTokensPayNow: '미납건 즉시납부',
      aiTokensPayNowSuccess: '결제 재시도를 요청했습니다.',
      aiTokensDetail: '상세 보기',
      aiTokensDetailTitle: 'AI 토큰 사용량',
      aiTokensMonth: '월',
      aiTokensThisMonthTotalUsed: '이번 달 총 사용량',
      aiTokensBaseUsed: '기본',
      aiTokensOverageUsed: '추가',
      aiTokensPreviewAmount: '예상 후불',
      aiTokensLimit: '월 리밋',
      aiTokensRemaining: '잔여',
      aiTokensUnlimited: '무제한',
      aiTokensBaseBalance: '기본 토큰 잔액',
      aiTokensBaseCapTooltip: '구독 시트 수에 따라 기본 토큰이 추가 지급될 수 있습니다.',
      aiTokensByFeature: '엔드포인트별 사용량',
      aiTokensAlerts: '알림(임계치)',
      aiTokensAlertsDisabled: '알림이 비활성화되어 있습니다.',
      aiTokensAlertSent: '발송됨',
      aiTokensAlertSentAt: '발송',
      aiTokensAlertTokens: '알림 임계치',
      aiTokensAlertEmails: '알림 수신 이메일',
      aiTokensUpdatedAt: '수정일',
      aiTokensLedgerDesc: '최근 내역(디버그/운영용)',
      aiTokensTestConsume: '테스트 차감',
      aiTokensTestConsumeTitle: '테스트 차감',
      aiTokensTestConsumeSubmit: '차감',
      aiTokensTestConsumeAmount: '차감 토큰 수',
      aiTokensTestConsumeFeature: 'feature',
      aiTokensTestConsumeIdempotencyKey: '멱등키',
      aiTokensTestConsumeIdempotencyKeyPh: '미입력 시 서버가 자동 생성',
      aiTokensTestConsumeMeta: '메모',
      aiTokensTestConsumeMetaPh: '프론트 테스트 차감',
    },
    profile: {
      editPhoto: '사진수정',
      nickname: '별명',
      personalColor: '퍼스널컬러',
      language: '언어',
      languages: {
        kr: '한국어',
        en: '영어',
        vi: '베트남어',
      },
      email: '이메일',
      authEmail: '이메일 인증',
      name: '이름',
      phone: '휴대폰번호',
      numberOnly: '숫자만 입력해주세요.',
      birth: '생년월일',
      gender: '성별',
      male: '남성',
      female: '여성',
      task: '업무',
      job: '직무',
      taskType: '업무성격',
      freelancer: '프리랜서',
      officer: '정규직',
      hopeLaborDay: '희망일당',
      pricePerDay: '천원 / 8시간',
      company: '회사',
      career: '경력',
      deleteCareer: '경력 삭제하기',
      companyName: '회사명',
      workPeriod: '근무 기간',
      dateError: '종료일이 시작일보다 빠를 수 없습니다.',
      level: '직급/직무',
      salaryYear: '연봉(천원)',
      addCareer: '경력 추가하기',
      setAccount: '계정 설정',
      addProfile: '프로필 등록',
      account: '계정',
      withdrawAccount: '회원 탈퇴',
      resetPassword: '비밀번호 재설정',
      agreeMarketing: '마케팅 동의',
      agreedAt: '동의일시',
      notification: '알림',
      notiAll: '전체 알림',
      notiAllMsg: '모든 알림 메시지를 수신합니다.',
      notiEmail: '이메일 알림',
      notiEmailMsg: '설정된 Email로 알림을 수신합니다.',
      notiNewTask: '새 업무 알림',
      notiNewTaskMsg: '담당자로 지정되었을 경우 알림을 수신합니다.',
      notiDelayed: '지연 알림',
      notiDelayedMsg: '지연된 스토리가 있을 경우 알림을 수신합니다.',
      notiReq: '업무 요청 알림',
      notiReqMsg: '나에게 새로운 요청이 생길 경우 알림을 수신합니다.',
      withdrawAsk: (nickname: string) => `${nickname}님, 정말 탈퇴하시겠습니까?`,
      withdrawMsg: [
        '지금 탈퇴하시면 진행 중이거나 진행 예정 작업들에 대해 문제가 발생할 경우,',
        '고객사에서 손해배상을 청구할 수 있습니다.',
        '지금 탈퇴하시면 현재 계정에 있는 데이터가 모두 사라져요.',
        '추후에 동일 계정으로 재가입하셔도 데이터는 복구되지 않습니다.',
      ],
      giveFeedback: '피드백 부탁드려요!',
      feedbackPlaceholder:
        '서비스 탈퇴 사유에 대해 말씀해 주시겠어요?&#10;아쉬운 부분에 대해 피드백 주시면 서비스 개선에 큰 도움이 됩니다.',
      withdrawCheckbox: '회원 탈퇴 유의사항을 확인하였으며 동의합니다.',
      resetPasswordSent: '비밀번호 재설정 이메일이 발송되었습니다. 이메일을 확인해주세요.',
      success: '프로필 등록에 성공하였습니다.',
      askDelete: '정말 삭제하시겠습니까?',
      careerFull: '경력을 더이상 추가하실 수 없습니다.',
    },
    epic: {
      epic: '에픽',
      epicLabel: '에픽 라벨',
      point: '포인트',
      weight: '비중',
      progress: '진척도',
      progressGap: '진척도 차이',
    },
    payment: {
      paymentFailure: '결제 실패',
      paymentFailureMessage: '결제에 실패했습니다.',
      paymentSuccess: '결제 성공',
      paymentSuccessMessage: '결제가 완료되었습니다.',
      confirm: '확인',
      close: '닫기',
    },
    doclist: {
      share: '공유',
      permission: '권한',
      addAiDoc: 'AI로 문서 생성하기',
      searchPlaceholder: '검색어를 입력하세요...',
      aiEdit: 'AI 수정',
      aiEditTitle: 'AI로 문서 수정',
      aiEditConfirm: '수정 적용',
      aiEditPromptLabel: '수정 지시사항',
      aiEditPromptPlaceholder: '예) 표 형식 개선, 결론 단락 보강, 중복 문장 정리 등',
      aiEditNote: '서버는 저장하지 않고 수정된 HTML만 반환합니다. 적용 시 자동 저장됩니다.',
      aiEditLoading: 'AI가 문서를 수정 중입니다...',
      loading: '로딩 중...',
      addDoc: '문서 추가',
      addFolder: '폴더 추가',
      selectDocumentPlaceholder: '문서를 선택하세요',
      selectDocumentContentPlaceholder: '문서를 선택하여 내용을 보거나 편집하세요.',
      reportCreatedSuccess: 'AI 보고서가 성공적으로 생성되었습니다.',
      confirm: {
        unsavedChanges: '저장되지 않은 변경사항이 있습니다. 계속하시겠습니까?',
        delete: '{title} 문서를 삭제하시겠습니까? 폴더인 경우 하위 문서/폴더도 모두 삭제됩니다.',
        deleteSimple: '문서를 삭제하시겠습니까? 폴더인 경우 하위 항목도 모두 삭제됩니다.',
      },
      toast: {
        aiEditApplied: 'AI 수정 결과가 적용되었습니다.',
        addSuccess: '{title}이(가) 추가되었습니다.',
        addFail: '문서 추가에 실패했습니다.',
        fetchFail: '문서 목록 로딩에 실패했습니다.',
        fetchContentFail: '문서 내용 로딩에 실패했습니다.',
        titleEmpty: '제목은 비워둘 수 없습니다.',
        titleUpdateSuccess: '제목이 성공적으로 업데이트되었습니다.',
        titleUpdateFail: '제목 업데이트에 실패했습니다.',
        fetchChildrenFail: '{title}의 하위 항목 로딩에 실패했습니다.',
        addSubSuccess: '하위 문서가 추가되었습니다.',
        addSubFail: '하위 문서 추가에 실패했습니다.',
        addRootSuccess: '새 문서가 추가되었습니다.',
        addRootFail: '새 문서 추가에 실패했습니다.',
        addFolderSuccess: '새 폴더가 추가되었습니다.',
        addFolderFail: '새 폴더 추가에 실패했습니다.',
        positionSaveFail: '새로운 위치 저장에 실패했습니다. 되돌립니다.',
        initFail: '컴포넌트 초기화 중 오류가 발생했습니다.',
        invalidProject: '잘못된 프로젝트 접근입니다.',
        contentSaveSuccess: '문서 내용이 저장되었습니다.',
        contentSaveFail: '문서 내용 저장에 실패했습니다.',
        shareLinkCopied: '공유 링크가 클립보드에 저장되었습니다.',
        deleteSuccess: '문서가 삭제되었습니다.',
        deleteFail: '문서 삭제에 실패했습니다.',
      },
      alt: {
        search: '검색',
        close: '닫기',
        editDelete: '수정/삭제',
        comment: '댓글',
        history: '기록',
      },
    },
    join: {
      profileSetup: '프로필을 설정해 주세요.',
      photoRegistration: '사진등록',
      nickname: '별명',
      nicknamePlaceholder: '15자 이내 텍스트',
      personalColor: '퍼스널컬러',
      email: '이메일',
      emailPlaceholder: 'example@eposo.ai',
      password: '비밀번호',
      passwordPlaceholder: '10자 이상 텍스트',
      passwordValidation: '10자 이상 20자 이하 텍스트를 입력해 주세요.',
      passwordConfirm: '비밀번호 확인',
      passwordMismatch: '입력한 비밀번호가 다릅니다.',
      name: '이름',
      phoneNumber: '휴대폰번호',
      phonePlaceholder: '숫자만 입력해주세요',
      birthday: '생년월일',
      gender: '성별',
      male: '남자',
      female: '여자',
      agree: '에 동의합니다.',
      optional: '(선택)',
      joinButton: '회원가입',
      emailVerification: '이메일 인증',
      emailVerifying: '인증대기',
      emailVerified: '인증됨',
      verify: '인증하기',
      invalidEmail: '유효하지 않은 이메일입니다',
      emailAlreadyUsed: '이미 사용중인 이메일입니다.',
      emailSent: '입력하신 이메일로 인증메일이 발송되었습니다.',
      joinComplete: '회원가입이 완료 되었습니다. 로그인해 주세요.',
      sessionExpired:
        '세션이 만료되었습니다. 개인정보 보안을 위하여 새로고침 후 다시 입력해주세요.',
      joinSuccess: '회원가입 성공!',
    },
    pilot: {
      title: '파일럿 페이지',
      description: '자동 코딩 기능 페이지입니다.',
      noHistory: 'AI 코딩 내역이 없습니다.',
      registeredRepositories: '등록된 저장소',
      addRepository: '저장소 추가',
      noRepositoryLinked: '연결된 저장소가 없습니다.',
      loadingHistory: '내역을 불러오는 중...',
      loadingRepositories: '저장소를 불러오는 중...',
      aiCodingHistory: 'AI 코딩 내역',
      deleteRepoConfirm: '정말로 이 저장소를 연결 해제하시겠습니까?',
      unlinkSuccess: '저장소 연결을 해제했습니다.',
      unlinkFailed: '저장소 연결 해제에 실패했습니다.',
      viewPr: 'PR 보기',
      loadingStories: '스토리 목록을 불러오는 중입니다...',
      loadingStoriesPlaceholder: '스토리를 가져오는 중...',
      unclassified: '미분류',
      autoCodingSettings: '자동 코딩 설정',
      autoApprovePRs: 'AI 생성 PR 자동 승인',
      autoApprovePRsDesc: '활성화하면 AI가 생성한 PR이 자동으로 승인됩니다.',
      enableAutoRetry: '배포 실패 시 자동 재시도',
      enableAutoRetryDesc: '활성화하면, 배포 실패 시 AI가 자동으로 코드 수정을 재시도합니다.',
      webhookIntegration: '웹훅(Webhook) 연동',
      webhookIntegrationDesc:
        'AI 코더가 생성한 PR이 머지될 때 배포 상태를 자동으로 추적하려면, 아래 안내에 따라 사용 중인 배포 플랫폼에 웹훅 URL을 등록하세요.',
      webhookVercelDesc: 'Vercel 프로젝트의 Settings > Integrations 메뉴에서 GitHub 연동을 확인하세요. Eposo AI가 생성한 PR이 머지되면, Vercel이 자동으로 배포를 시작하고 GitHub에 상태를 업데이트합니다.',
      webhookRailwayDesc: 'Railway 프로젝트의 Settings > Webhooks 메뉴로 이동하여 URL을 등록하세요.',
      fetchRepositoriesFailed: '등록된 저장소 목록을 불러오는데 실패했습니다.',
      fetchDeploymentTargetsFailed: '배포 대상 목록을 불러오는데 실패했습니다.',
      updateDeploymentTargetSuccess: '배포 대상이 성공적으로 업데이트되었습니다.',
      addDeploymentTargetSuccess: '배포 대상이 성공적으로 추가되었습니다.',
      saveDeploymentTargetFailed: '배포 대상 저장에 실패했습니다.',
      confirmDeleteDeploymentTarget: '정말로 이 배포 대상을 삭제하시겠습니까?',
      deleteDeploymentTargetSuccess: '배포 대상이 성공적으로 삭제되었습니다.',
      deleteDeploymentTargetFailed: '배포 대상 삭제에 실패했습니다.',
      startAiCoding: 'AI 코드 작업',
      runAiCoding: 'AI 코딩 작업 실행',
      instruction: '작업 지시사항',
      instructionPlaceholder: 'AI에게 내릴 구체적인 코딩 지시사항을 입력하세요. (예: "로그인 API 엔드포인트를 추가해줘.")',
      filePath: '대상 파일 경로',
      filePathPlaceholder: '코드를 수정하거나 추가할 파일의 전체 경로를 입력하세요. (예: "src/user/user.service.ts")',
      relatedStory: '관련 스토리',
      selectStory: '스토리를 선택하세요',
      run: '실행',
      taskStarted: 'AI 코딩 작업을 시작했습니다. 작업 내역에서 상태를 확인할 수 있습니다.',
      taskStartFailed: 'AI 코딩 작업 시작에 실패했습니다.',
      fetchStoriesFailed: '스토리 목록을 불러오는 데 실패했습니다.',
      generateInstruction: 'AI 지시사항 생성',
      generatingInstruction: 'AI가 지시사항을 생성하는 중입니다...',
      generateInstructionFailed: '지시사항 생성에 실패했습니다.',
      // Deployment Environment
      environmentVariables: '환경 변수',
      fetchEnvironmentsFailed: '환경 변수를 불러오는 데 실패했습니다.',
      updateEnvironmentSuccess: '환경 변수가 성공적으로 업데이트되었습니다.',
      updateEnvironmentFailed: '환경 변수 업데이트에 실패했습니다.',
      generate: '자동 생성',
      secretGenerated: '새로운 시크릿 값이 생성되었습니다. 저장 버튼을 눌러주세요.',
      repoAndTargetManagement: '저장소 및 배포 대상 관리',
      noRepositories: '등록된 저장소가 없습니다. GitHub 앱을 설치하고 저장소를 등록해주세요.',
      addDeploymentTarget: '배포 대상 추가',
      editDeploymentTarget: '배포 대상 수정',
      noDeploymentTargets: '등록된 배포 대상이 없습니다.',
      deploymentTargetLabel: '레이블',
      deploymentPlatform: '플랫폼',
      serviceIdentifier: '서비스 식별자',
      apiToken: 'API 토큰',
      noEnvironmentVariables: '설정된 환경변수가 없습니다. AI 코딩 작업 시 필요한 환경변수는 자동으로 감지하여 추가됩니다.',
      setupGuide: '설정 가이드',
      resyncButtonText: '환경변수 동기화',
      resyncingButtonText: '동기화 중...',
      resyncFailedMessage: '환경변수 동기화 요청에 실패했습니다.',
      resyncTooltipText:
        '현재 코드와 배포 플랫폼(Vercel, Railway)의 환경변수를 스캔하여 최신 상태로 동기화합니다. 더 이상 사용되지 않는 변수는 자동으로 삭제됩니다.',
      addTargetTooltipText: '코드를 배포할 Vercel 또는 Railway 프로젝트 정보를 등록합니다.',
      resyncInProgress: '이미 환경변수 동기화 작업이 진행 중입니다.',
      resyncSuccess: '환경변수 동기화가 성공적으로 완료되었습니다.',
      resyncFailed: '환경변수 동기화에 실패했습니다. 로그를 확인해주세요.',
      resyncStatusFailed: '동기화 실패',
      taskInProgress: '이미 자동 코딩 작업이 진행 중입니다.',
      aiSetup: 'AI 설정',
      autoSetupSuccess: '환경변수 값이 자동으로 설정되었습니다.',
      autoSetupFailed: '환경변수 자동 설정에 실패했습니다.',
      status: {
        pending: '대기 중',
        in_progress: '진행 중',
        succeeded: '성공',
        failed: '실패',
        cancelled: '취소됨',
        pending_review: '검토 대기중',
        retrying: '재시도 중',
      },
      deploymentStatus: {
        deploying: '배포 중',
        verifying: '검증 중',
        verification_failed: '검증 실패',
        succeeded: '배포 성공',
        failed: '배포 실패',
      },
      deploy: '배포하기',
      deployStartedSuccess: '배포 작업이 성공적으로 시작되었습니다.',
      deployStartedFailed: '배포 작업을 시작하지 못했습니다.',
      runDeployment: '수동 배포 실행',
      selectRepository: '저장소 선택',
      selectRepositoryPlaceholder: '배포할 저장소를 선택해주세요.',
      startDeployment: '배포 작업',
      runAiCodeTask: 'AI 코드 작업',
      repoName: '저장소',
      branchName: '브랜치',
      createdAt: '생성일',
      workSummary: '작업 내용',
      viewWorkSummary: '내용 보기',
      viewLogs: '로그 보기',
    },
  },
  status: {
    timeline: {
      completed: '완료',
      inProgress: '진행',
      pending: '대기',
      delayed: '지연',
      considering: '검토중',
      rejected: '거부',
      approving: '승인중',
      approved: '승인완료',
    },
    request: {
      awaiting: '대기',
      inProgress: '진행',
      completed: '완료',
    },
    contract: {
      completed: '완료',
      inProgress: '진행',
      rejected: '거부',
    },
  },
  validation: {
    email: {
      registered: '이미 등록된 이메일 입니다.',
      invalidFormat: '올바른 이메일 형식이 아닙니다.',
    },
    name: {
      required: '이름을 입력해 주세요.',
      maxLength15: '15자 이내로 작성해주세요.',
    },
    nickname: {
      required: '닉네임을 입력해주세요.',
      maxLength15: '15자 이내로 작성해주세요.',
    },
    password: {
      length: '10자 이상 20자 이하 텍스트를 입력해 주세요.',
    },
    phone: {
      required: '휴대폰 번호를 입력해주세요.',
    },
  },
  alert: {
    docType: {
      selectType: '문서 유형을 선택해주세요.',
      selectDateRange: '보고서 기간을 선택해주세요.',
      apiResponseError: 'API 응답 처리 중 오류가 발생했습니다.',
      creationError: '문서 생성 중 오류가 발생했습니다.',
    },
    selectDocType: '문서 유형을 선택해주세요.',
    reportNeedsDates: '보고서 유형은 데이터 수집 기간을 모두 선택해야 합니다.',
    startDateAfterEndDate: '시작일은 종료일보다 이전이어야 합니다.',
    invalidFileTypeForAI: 'AI 타임라인 생성에는 PDF, Word, TXT, CSV 파일만 업로드할 수 있습니다.',
    fileSizeExceededSimple: '파일 크기가 10MB를 초과할 수 없습니다.',
    errorNeedProjectId: '타임라인을 생성하려면 먼저 프로젝트를 선택해야 합니다.',
    aiTimelineCreatedSuccess: '파일로부터 AI 타임라인 생성을 요청했습니다. 잠시 후 반영됩니다.',
    aiTimelineCreationFailed: 'AI 타임라인 생성 요청에 실패했습니다. 잠시 후 다시 시도해주세요.',
  },
  settlement: {
    settlementMonth: '정산 월',
    settlementDate: '정산 일자',
    monthly: '매월',
    day: '일',
    projectTotalAmount: '프로젝트 합계 금액',
    use: '사용',
    currency: '원',
    previous: '이전',
    targets: '대상자',
    monthlyTotal: '월간 합계',
    totalSettlementAmount: '총 정산 금액',
    download: '다운로드',
    fullTime: '정규직',
    freelancer: '프리렌서',
    targetAssignment: '대상자 지정',
    workingHours: '근무 시간',
    participationRate: '참여율',
    previousSalary: '직전 연봉',
    salaryAdjustment: '연봉 조정',
    participationRateAdjustment: '참여율 조정',
    workingHoursAdjustment: '근무 시간 조정',
    desiredHourlyWage: '희망 시급',
    hourlyWageAdjustment: '시급 조정',
    monthlySettlementAmount: '월간 정산 금액',
    totalSettlementAmountColumn: '총 정산 금액',
    thousandWon: '천원',
    hours: '시간',
    thousandWonPerHour: '천원 / h',
    noStoriesInPeriod: '기간 내 진행한 스토리가 없습니다.',
    onlyDisplayedStoriesAdded: '표시된 스토리만 추가됩니다.',
    more: '더보기',
  },
};
